import { ShoppingBag } from 'lucide-react'

interface OrderDetailsProps {
  data: any
}

export function OrderDetails({ data }: OrderDetailsProps) {
  return (
    <div
      className="max-w-xs"
      style={{ fontFamily: 'var(--wn-font)' }}
    >
      <div className="flex items-center gap-2.5 pb-2.5 border-b border-[#edf1f7]">
        <div
          className="h-9 w-9 rounded-[10px] flex items-center justify-center shrink-0"
          style={{ background: '#E8F8F0' }}
        >
          <ShoppingBag className="h-4 w-4" style={{ color: '#1EB677' }} />
        </div>
        <div className="flex-1 min-w-0">
          <div
            className="truncate"
            style={{ fontFamily: 'var(--wn-font)', fontSize: 13, fontWeight: 700, color: '#101828' }}
          >
            Order Details
          </div>
          <div
            className="truncate mt-0.5"
            style={{ fontFamily: 'var(--wn-font)', fontSize: 11, fontWeight: 500, color: '#6a7282' }}
          >
            Shopping cart
          </div>
        </div>
      </div>
      <div className="mt-2.5 space-y-1.5">
        {data.cart && Array.isArray(data.cart) && (
          <div
            className="flex items-baseline gap-1.5"
            style={{ fontFamily: 'var(--wn-font)', fontSize: 12 }}
          >
            <span style={{ color: '#6a7282', fontWeight: 600 }}>Items:</span>
            <span style={{ color: '#101828', fontWeight: 500 }}>{data.cart.length}</span>
          </div>
        )}
        {data.order && data.order.total && (
          <div
            className="flex items-baseline gap-1.5"
            style={{ fontFamily: 'var(--wn-font)', fontSize: 12 }}
          >
            <span style={{ color: '#6a7282', fontWeight: 600 }}>Total:</span>
            <span style={{ color: '#101828', fontWeight: 500 }}>₹{data.order.total}</span>
          </div>
        )}
      </div>
    </div>
  )
}
